import { ReactElement } from 'react';
import style from './Amenities.module.scss';

interface Props {
  amenities: Dict;
}

export default function LocationDetailAmenities(props: Props): ReactElement {
  return (
    <ul className={ style.list }>
      {
        props.amenities.map(({ amenity }) => (
          <li
            className={ style.item }
            key={ amenity.id }
          >
            <div
              className={ style.icon }
              style={ { maskImage: `url(/images/icons/amenities/${ amenity.slug }.svg)`, WebkitMaskImage: `url(/images/icons/amenities/${ amenity.slug }.svg)` } } />
            <span>{ amenity.name }</span>
          </li>
        ))
      }
    </ul>
  );
}
